import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import App from "./App";
import ThankYou from "./pages/ThankYou";
import MySubmissionsPage from "./pages/MySubmissionsPage";
import MySubmissionDetailPage from "./pages/MySubmissionDetailPage";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminList from "./pages/admin/AdminList";
import AdminDetail from "./pages/admin/AdminDetail";
import FormEditor from "./pages/admin/FormEditor";
import ColumnsPage from "./pages/admin/ColumnsPage";
import ProgressStagesPage from "./pages/admin/ProgressStagesPage";
import AdminsPage from "./pages/admin/AdminsPage";
import NotificationRecipientsPage from "./pages/admin/NotificationRecipientsPage";
import CheckpointsPage from "./pages/admin/CheckpointsPage";
import DatabaseInfoPage from "./pages/admin/DatabaseInfoPage";
import { setFormConfigData } from "./formConfig";
import { fetchFormConfigSections } from "./api/admin";
import "./styles.css";

async function bootstrap() {
  const sections = await fetchFormConfigSections();
  if (sections && sections.length > 0) setFormConfigData(sections);
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/thanks" element={<ThankYou />} />
          <Route path="/submissions" element={<MySubmissionsPage />} />
          <Route path="/submissions/:id" element={<MySubmissionDetailPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminList />} />
            <Route path="columns" element={<ColumnsPage />} />
            <Route path="progress-stages" element={<ProgressStagesPage />} />
            <Route path="admins" element={<AdminsPage />} />
            <Route path="notifications" element={<NotificationRecipientsPage />} />
            <Route path="checkpoints" element={<CheckpointsPage />} />
            <Route path="database" element={<DatabaseInfoPage />} />
            <Route path="form-editor" element={<FormEditor />} />
            <Route path="submissions/:id" element={<AdminDetail />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  );
}

bootstrap();
